/**
 * What the first screen doesn't need waits for it (main.tsx): the offline cache, Sentry, PostHog
 * and Meta's pixel start once that screen has replaced the loading skeleton (index.html) and Home's
 * hero shows its first frame, so a slow phone or network spends itself on the screen first.
 */

/** The longest wait for the hero after the first screen (ms): other screens have none. */
const HERO_WAIT_MS = 4000;

let markHero = () => {};
const heroIn = new Promise<void>((resolve) => {
  markHero = resolve;
});

/** Home's hero shows its first frame, or gave up on it (HeroVideo). */
export function heroShown(): void {
  markHero();
}

/** Runs `start` once the first screen is in, its hero too, and the browser has a quiet moment. */
export function afterFirstScreen(start: () => void): void {
  const root = document.getElementById('root')!;
  new MutationObserver((_, observer) => {
    observer.disconnect();
    const wait = new Promise((resolve) => setTimeout(resolve, HERO_WAIT_MS));
    void Promise.race([heroIn, wait]).then(() => {
      if ('requestIdleCallback' in window) requestIdleCallback(() => start(), { timeout: 2000 });
      else setTimeout(start, 500);
    });
  }).observe(root, { childList: true });
}
